module.exports = __webpack_public_path__ + "images/1.1789608252531.jpg";